export default {
  payments: [],
};
